var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"18","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 .5h18v3H0v-3z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }